export default __webpack_public_path__ + "static/media/1 logo UNICA bd.cf959a71.jpg";